import { AutomationsPresentationV1 } from 'Automations/automationEditor'

/**
 * A workflow node that performs no work on its own: the start trigger, the
 * terminal end node, and free-floating notes. A design containing only these is
 * equivalent to our inert no-op placeholder workflow — there is nothing to run.
 */
const isNonOperationalNodeType = (type: string | undefined): boolean => {
  if (!type) return true
  return type === 'END' || type === 'NOTE' || type.startsWith('START_')
}

/**
 * True when the design contains no operational node (review / action / reminder
 * / switch) between the start and end — i.e. it would publish as our no-op
 * workflow, which does nothing. Placeholder nodes count as operational: the
 * user has started building, and their own required-field validation blocks the
 * publish, so we do not want to also report the workflow as empty.
 */
export const isNoopWorkflow = (
  presentation: AutomationsPresentationV1
): boolean =>
  presentation.nodes.every(node => isNonOperationalNodeType(node.type))
